import { useState, useEffect } from 'react';

export const PWAInstall = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [showiOSInstructions, setShowiOSInstructions] = useState(false);
  const [showMacInstructions, setShowMacInstructions] = useState(false);

  useEffect(() => {
    // Détecter si déjà installé
    if (window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone) {
      setIsInstalled(true);
      return;
    }

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
    if (isIOS) {
      setShowiOSInstructions(true);
      return;
    }

    // Détecter Mac Safari (Sonoma+)
    const isMac = /Macintosh/i.test(navigator.userAgent);
    const isSafari = navigator.vendor === 'Apple Computer, Inc.' && !/Chrome/i.test(navigator.userAgent);
    if (isMac && isSafari) {
      setShowMacInstructions(true);
      return;
    }

    const handler = (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setDeferredPrompt(null);
    }
  };

  if (isInstalled) return null;

  // Rendu spécifique iOS
  if (showiOSInstructions) {
    return (
      <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-[100] w-[90%] max-w-sm animate-in fade-in slide-in-from-bottom duration-500">
        <div className="bg-white border-2 border-foret-600 rounded-2xl p-4 shadow-2xl relative">
          {/* Petite flèche pointant vers le bas (pour le bouton partager de Safari) */}
          <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-4 h-4 bg-white border-r-2 border-b-2 border-foret-600 rotate-45"></div>
          
          <div className="flex flex-col items-center gap-3 text-center">
            <div className="w-12 h-12 bg-foret-50 rounded-xl flex items-center justify-center text-foret-600">
              <i className="ri-apple-line text-2xl" />
            </div>
            <div>
              <h4 className="font-bold text-gray-900 text-sm">Installer sur iPhone</h4>
              <p className="text-[11px] text-gray-500 mt-1 leading-relaxed">
                Appuyez sur l&apos;icône <strong className="text-blue-600 font-black">Partager</strong> (le carré avec une flèche) puis sur <strong className="text-gray-900 font-black">&quot;Sur l&apos;écran d&apos;accueil&quot;</strong>.
              </p>
            </div>
            <button 
              onClick={() => setShowiOSInstructions(false)}
              className="text-[10px] font-bold text-gray-400 uppercase tracking-widest hover:text-gray-600"
            >
              Ignorer
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Rendu spécifique Mac Safari
  if (showMacInstructions) {
    return (
      <div className="fixed bottom-20 right-4 z-[100] w-64 animate-in fade-in slide-in-from-right duration-500">
        <div className="bg-white border-2 border-terre-600 rounded-2xl p-4 shadow-2xl">
          <div className="flex flex-col items-center gap-3 text-center">
            <div className="w-12 h-12 bg-terre-50 rounded-xl flex items-center justify-center text-terre-600">
              <i className="ri-mac-line text-2xl" />
            </div>
            <div>
              <h4 className="font-bold text-gray-900 text-sm">Installer sur Mac</h4>
              <p className="text-[11px] text-gray-500 mt-1 leading-relaxed">
                Allez dans <strong className="text-gray-900 font-black">Fichier</strong> puis cliquez sur <strong className="text-terre-600 font-black">&quot;Ajouter au Dock&quot;</strong> pour utiliser l&apos;application.
              </p>
            </div>
            <button 
              onClick={() => setShowMacInstructions(false)}
              className="text-[10px] font-bold text-gray-400 uppercase tracking-widest hover:text-gray-600"
            >
              Ignorer
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Rendu standard (Android/Chrome)
  if (!deferredPrompt) return null;

  return (
    <div className="fixed bottom-20 right-4 z-[90] animate-bounce">
      <button
        onClick={handleInstallClick}
        className="flex items-center gap-3 bg-foret-600 text-white px-5 py-3 rounded-2xl shadow-xl hover:bg-foret-700 transition-all border-2 border-white/20 group"
      >
        <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
          <i className="ri-download-cloud-2-line text-lg" />
        </div>
        <div className="text-left">
          <p className="text-[10px] font-bold opacity-80 leading-none mb-1 uppercase tracking-tight">Application</p>
          <p className="text-sm font-black leading-none">INSTALLER</p>
        </div>
      </button>
    </div>
  );
};
